import { render, staticRenderFns } from "./dataCard.vue?vue&type=template&id=f9c40214&scoped=true"
import script from "./dataCard.vue?vue&type=script&lang=js"
export * from "./dataCard.vue?vue&type=script&lang=js"
import style0 from "./dataCard.vue?vue&type=style&index=0&id=f9c40214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c40214",
  null
  
)

export default component.exports